import { ReactNode } from 'react';
import { AutocompleteRenderGetTagProps, ChipProps } from '@mui/material';

import { Chip } from '../../Chip';
import { GetChipProps } from '../types';

export interface RenderChipsParams<Value> {
  chipProps: ChipProps;
  getChipProps?: GetChipProps<Value>;
  getTagProps: AutocompleteRenderGetTagProps;
  value: Value[];
}

export function renderChips<Value>({
  chipProps,
  getChipProps,
  getTagProps,
  value,
}: RenderChipsParams<Value>): ReactNode {
  return value.map((option, index) => {
    const externalChipProps = getChipProps?.(option, index, value) ?? {};

    return (
      <Chip
        {...chipProps}
        label={option as ReactNode}
        {...externalChipProps}
        {...getTagProps({ index })}
      />
    );
  });
}
